import { Icon } from "@iconify/react/dist/iconify.js";
import { Fragment, useEffect, useRef } from "react";
import { register } from "swiper/element/bundle";
import { SwiperProps } from "swiper/react";
import Container from "../Grid/Container";
import IconSolarPanels from "@resources/panele-sloneczne.png?format=webp&quality=90&imagetools";
import IconHighStandard from "@resources/wysoki-standard.png?format=webp&quality=90&imagetools";
import IconVideophone from "@resources/wideomofon.png?format=webp&quality=90&imagetools";
import IconBalanceRoom from "@resources/balance-room.png?format=webp&quality=90&imagetools";

register();

const features = [
    {
        key: "monitoring",
        icon: "/storage/icons/cctv-camera2.svg",
        text: (
            <>
                Monitoring i ochrona
                <br />
                w budynku
            </>
        ),
    },
    {
        key: "solar",
        icon: IconSolarPanels,
        text: (
            <>
                Panele słoneczne
                <br />
                do zasilania cz. wspólnych
            </>
        ),
    },
    {
        key: "layouts",
        icon: "/storage/icons/silhouette2.svg",
        text: (
            <>
                Funkcjonalne układy mieszkań
                <br />
                od 25 do ponad 100 m²
            </>
        ),
    },
    {
        key: "balance-room",
        icon: IconBalanceRoom,
        text: <>Balance room</>,
    },
    {
        key: "finish-standard",
        icon: IconHighStandard,
        text: (
            <>
                Wysoki standard
                <br />
                wykończenia
            </>
        ),
    },
    {
        key: "terraces",
        icon: "/storage/icons/sunbed2.svg",
        text: (
            <>
                W pełni wykończone
                <br />
                tarasy i balkony
            </>
        ),
    },
    {
        key: "breeam",
        icon: "/storage/icons/hero-features/certificate@2x.png",
        text: (
            <>
                Budynek przyjazny środowisku
                <br />– BREEAM
            </>
        ),
    },
    {
        key: "videophone",
        icon: IconVideophone,
        text: <>Wideodomofony</>,
    },
    {
        key: "windowsills",
        icon: "/storage/icons/window2.svg",
        text: (
            <>
                Parapety
                <br />z konglomeratu
            </>
        ),
    },
];

const HeroFeatures = () => {
    const swiperRef = useRef<HTMLElement>(null);

    useEffect(() => {
        if (!swiperRef.current) {
            return;
        }

        const swiperContainer = swiperRef.current;
        const params: SwiperProps = {
            slidesPerView: 2,
            spaceBetween: 16,
            grabCursor: true,
            speed: 500,
            loop: features.length > 4,
            autoplay: {
                delay: 3500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                },
            },
            navigation: {
                prevEl: ".hero-features-prev",
                nextEl: ".hero-features-next",
            },
        };

        // @ts-ignore
        Object.assign(swiperContainer, params);
        // @ts-ignore
        swiperContainer.initialize();
    }, []);

    return (
        <section className="bg-white/80 py-8">
            <Container>
                <div className="relative">
                    {/* @ts-ignore */}
                    <swiper-container ref={swiperRef} init="false">
                        {features.map((feature) => (
                            <Fragment key={feature.key}>
                                {/* @ts-ignore */}
                                <swiper-slide>
                                    <div className="flex flex-col items-center justify-start gap-6 px-2 h-full">
                                        {feature.icon ? (
                                            <img
                                                src={feature.icon}
                                                alt=""
                                                width={72}
                                                height={72}
                                                className="size-[72px] object-contain shrink-0"
                                            />
                                        ) : (
                                            <div
                                                className="size-[72px] shrink-0 border border-primary/40 bg-transparent"
                                                aria-hidden
                                            />
                                        )}
                                        <p className="md:text-p md:leading-p text-sm text-primary font-extrabold uppercase text-center tracking-p w-full">
                                            {feature.text}
                                        </p>
                                    </div>
                                    {/* @ts-ignore */}
                                </swiper-slide>
                            </Fragment>
                        ))}
                        {/* @ts-ignore */}
                    </swiper-container>

                    <div className="flex justify-center gap-4 mt-6">
                        <button
                            type="button"
                            className="hero-features-prev glass-style px-6 py-3 rounded-[60px]"
                            aria-label="Poprzedni atut"
                        >
                            <Icon
                                icon="oui:arrow-left"
                                className="text-primary"
                                width={32}
                                height={32}
                            />
                        </button>
                        <button
                            type="button"
                            className="hero-features-next glass-style px-6 py-3 rounded-[60px]"
                            aria-label="Następny atut"
                        >
                            <Icon
                                icon="oui:arrow-right"
                                className="text-primary"
                                width={32}
                                height={32}
                            />
                        </button>
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default HeroFeatures;
